import React,{useState} from 'react';
import { useAuth } from '../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { CredentialResponse, GoogleLogin, useGoogleLogin, useGoogleOneTapLogin } from '@react-oauth/google';
import { useMessage } from '../context/MessageContext';
import { AxiosError } from 'axios';
import classes from "./Form.module.css"
import GoogleButton from '../components/GoogleButton';
import styles from "./Login.module.css"
import AppleButton from '../components/AppleButton';
import { Capacitor } from '@capacitor/core';
const errors = {
  INVALID_EMAIL: 1002,
  INVALID_PASSWORD: 1003,
}
function Login() {
  const {login, googleLogin} = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const {message} = useMessage();
  const [error, setError] = useState(null)
  const handleLogin = () =>{
      setError(null)
      login({email, password}).then((res)=>{
              navigate("/");
               //-- console.log(res)
          }).catch(err => {

            let msg =  err.message
             //-- console.log("login error", {err})
            setError(err.errorCode);
            message.error(msg)
          })
  }
  const onGoogleLogin = () =>{
     // navigate("/");
  }
  return (
    <div className={styles.login}>
      <h1 className={styles.title}>Login</h1>
      <div className={'form'}>
        <input onChange={(e) =>setEmail(e.target.value)} value={email} type='email' placeholder='email' autoComplete='email'></input>
        <input onChange={(e) =>setPassword(e.target.value)} value={password} type='password' placeholder='password' autoComplete='password'></input>
        <button type='submit' onClick={handleLogin}>Submit</button>
        <p>- or - </p>
        <GoogleButton onSuccess={onGoogleLogin} onError={message.error}>Sign in with google</GoogleButton>
        {Capacitor.getPlatform() == "ios" ? <AppleButton onSuccess={()=>{}} onError={message.error}>Sign in with apple</AppleButton> : null}
        <p>Don't have an account yet? <Link to={"/register"}>Register</Link></p>
        <p>forgot password? <Link to={"/reset-password"} state={{email}} >Reset</Link></p>
  
        {/* <GoogleLogin onSuccess={handleGoogleLogin} onError={()=>  //-- console.log("Error google login")}/> */}
      </div>
    </div>
  );
}

export default Login;
